import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import MobileMenu from './MobileMenu';
import Sidebar from './Sidebar';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const isSuperAdmin = location.pathname === '/super-admin';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* 모바일 사이드바 */}
      <MobileMenu open={sidebarOpen} setOpen={setSidebarOpen} />
      
      {/* 데스크톱 사이드바 */}
      <Sidebar />
      
      {/* 메인 콘텐츠 */}
      <div className="lg:pl-64 flex flex-col flex-1">
        {/* 헤더 */}
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* 페이지 콘텐츠 */}
        <main className="py-6 flex-1">
          <div className={`mx-auto ${isSuperAdmin ? 'max-w-7xl' : 'max-w-7xl'} px-4 sm:px-6 lg:px-8`}>
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;





